export const masterServiceAgreementDetails = {
    version: 4,
    lastUpdated: '09/10/2024',
};
